import React, { useState, useEffect, useRef } from 'react'
import Navbar from './components/Navbar/Navbar'
import HeroSection from './sections/HeroSection/HeroSection'
import LogoStrip from './sections/LogoStrip/LogoStrip'
import AboutSection from './sections/AboutSection/AboutSection'
import AmenitiesCarousel from './sections/AmenitiesCarousel/AmenitiesCarousel'
import PodiumAmenitiesCarousel from './sections/PodiumAmenitiesCarousel/PodiumAmenitiesCarousel'
import AmenitiesSection from './sections/AmenitiesSection/AmenitiesSection'
import LocationSection from './sections/LocationSection/LocationSection'
import PlanLayout from './sections/PlanLayout/PlanLayout'
import CTASection from './sections/CTASection/CTASection'
import CTAPopup from './components/CTAPopup/CTAPopup'

const App = () => {
  const [popupOpen, setPopupOpen] = useState(false)
  const timerRef = useRef(null)

  // First popup: 5s after page load
  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setPopupOpen(true)
    }, 5000)

    return () => clearTimeout(timerRef.current)
  }, [])

  // Next popup: 30s after user closes — not 30s after page load
  const handleClose = () => {
    setPopupOpen(false)

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setPopupOpen(true)
    }, 30000)
  }

  return (
    <>
      <Navbar />
      <HeroSection />
      <LogoStrip />
      <AboutSection />
      <LocationSection />
      <AmenitiesCarousel />
      <PlanLayout />
      <PodiumAmenitiesCarousel />
      <AmenitiesSection />
      <CTASection />

      <CTAPopup
        isOpen={popupOpen}
        onClose={handleClose}
        title="An Exclusive Opportunity Awaits"
        subtitle="Limited residences remain at The Everett. Register your interest today and our team will reach you with priority pricing, floor plans and an exclusive site visit invitation."
      />
    </>
  )
}

export default App